/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { Button, Grid, WithStyles, withStyles } from "@material-ui/core";
import * as React from "react";

import { userTitleItems } from "../../config";
import { User } from "../../models/User.model";
import { theme } from "../../theme/theme";
import { Form } from "../../types/Form";
import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";
import InputEmail from "../InputEmail/InputEmail";
import InputPhone from "../InputPhone/InputPhone";
import InputRadio from "../InputRadio/InputRadio";
import InputText from "../InputText/InputText";
import { styles } from "./FormProfil.style";

interface FormProfilProps extends WithStyles<typeof styles> {
    defaultUser: User;
    onSubmit: (user: User) => void;
    onCancel?();
}

type FormProfilState = {
    form: Form<User>;
};

class FormProfil extends React.Component<FormProfilProps, FormProfilState> {
    protected formBuilder: any = null;

    constructor(props: FormProfilProps) {
        super(props);
        this.formBuilder = new UiFormBuilder<User>()
            .addField("title", {
                props: {
                    label: "Civilité",
                    items: userTitleItems,
                    required: true,
                },
            })
            .addField("firstname", {
                props: {
                    label: "Prénom",
                    placeholder: "Saisir le prénom",
                    required: true,
                },
            })
            .addField("lastname", {
                props: {
                    label: "Nom",
                    placeholder: "Saisir le nom",
                    required: true,
                },
            })
            .addField("vendorCode", {
                props: {
                    label: "AG2R - Code vendeur",
                    placeholder: "Saisir le code",
                },
            })
            .addField("bringerCode", {
                props: {
                    label: "Code apporteur",
                    placeholder: "Saisir le code",
                    required: true,
                },
            })
            .addField("agencyCode", {
                props: {
                    label: "Code agence",
                    placeholder: "Saisir le code",
                },
            })
            .addField("counsellorCode", {
                props: {
                    label: "La Mondiale - Code conseiller C",
                    placeholder: "Saisir le code",
                },
            })
            .addField("agentCode", {
                props: {
                    label: "Code Agent",
                    placeholder: "Saisir le code",
                },
            })
            .addField("nsoCode", {
                props: {
                    label: "Code NSO",
                    placeholder: "Saisir le code",
                },
            })
            .addField("email", {
                props: {
                    label: "Email",
                    placeholder: "Saisir l'email",
                    disabled: true,
                },
            })
            .addField("phone", {
                props: {
                    label: "Téléphone",
                    placeholder: "ex. 01 01 01 01 01",
                    legend: "+334 93 55 01 01 (pour l'international)",
                },
            })
            .onChange(this.onChange.bind(this));

        this.state = {
            form: {
                fields: {},
                errors: [],
                values: this.props.defaultUser,
            },
        };
    }

    public onChange(fieldName: string, value: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        let form = builder.exec(this.state.form);
        this.setState({ form: form });
    }

    public onSubmit(e) {
        e.preventDefault();
        let user = this.state.form.values;
        user.profileCompleted = true;
        this.props.onSubmit(user);
    }

    public render() {
        if (!this.state) {
            return null;
        }

        const uiForm = this.formBuilder.build(this.state.form);
        const { classes } = this.props;

        return (
            <form onSubmit={this.onSubmit.bind(this)}>
                <Grid container={true} spacing={16}>
                    <Grid item={true} sm={12}>
                        <InputRadio {...uiForm.fields.title} />
                    </Grid>
                    <Grid item={true} sm={6}>
                        <InputText {...uiForm.fields.lastname} />
                    </Grid>
                    <Grid item={true} sm={6}>
                        <InputText {...uiForm.fields.firstname} />
                    </Grid>
                    {this.props.defaultUser.company.name === "mutuelledepoitiers" && (
                        <>
                            <Grid item={true} sm={6}>
                                <InputText {...uiForm.fields.agentCode} />
                            </Grid>
                            <Grid item={true} sm={6}>
                                <InputText {...uiForm.fields.nsoCode} />
                            </Grid>
                        </>
                    )}
                    {this.props.defaultUser.company.name === "ag2r" ? (
                        <>
                            <Grid item={true} sm={6}>
                                <InputText {...uiForm.fields.vendorCode} />
                            </Grid>
                            <Grid item={true} sm={6}>
                                <InputText {...uiForm.fields.counsellorCode} />
                            </Grid>
                        </>
                    ) : (
                        <Grid item={true} sm={6}>
                            <InputText {...uiForm.fields.bringerCode} />
                        </Grid>
                    )}
                    <Grid item={true} sm={6}>
                        <InputText {...uiForm.fields.agencyCode} />
                    </Grid>
                    <Grid item={true} sm={6}>
                        <InputPhone {...uiForm.fields.phone} />
                    </Grid>
                    <Grid item={true} sm={12}>
                        <InputEmail {...uiForm.fields.email} />
                    </Grid>
                    <Grid container={true} item={true} sm={12} justify="center" className={classes.submit}>
                        <Button type="submit" color="primary" variant="contained">
                            Valider
                        </Button>
                        {this.props.onCancel ? (
                            <Button
                                style={{ marginLeft: theme.spacing.unit }}
                                onClick={this.props.onCancel}
                                variant="outlined"
                                type="submit"
                                color="primary"
                            >
                                Annuler
                            </Button>
                        ) : null}
                    </Grid>
                </Grid>
            </form>
        );
    }
}

export default withStyles(styles)(FormProfil);



// WEBPACK FOOTER //
// ./src/components/FormProfil/FormProfil.tsx